var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.topState&&!_vm.isMobile())?_c('div',{staticClass:"top-box"},[_c('div',{staticClass:"top",on:{"click":_vm.goTop}},[_c('img',{staticClass:"top-img",attrs:{"src":require("../../static/img/go_top.png"),"alt":"图片"}})])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }